// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PFXe","colBig":"styles_colBig__2Z_kx","colSmall":"styles_colSmall__2QJYB"};